import produce from "immer";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { startEditAlert } from "../../actions/alertAction";
import {
  getSelectedForm,
  startLoadFormDetails,
} from "../../actions/formListAction";
import { startEditModal } from "../../actions/modalAction";
import { AppState } from "../../reducers/rootReducer";
import RowElement from "../elementComponents/RowElement";
import formCss from "./utils/formCss";
import ModalComponent from "../util/modal";
import "./previewComponent.scss";
import { getViewRemark } from "../../selectors/appSelectors";
import { Tooltip } from "react-tippy";
import Switch from "react-switch";
import { startEditSession } from "../../actions/sessionListAction";
import {
  downloadRemarkPdf
} from "../../actions/formListAction";

type TParams = { id: string };

const PreviewComponennt = ({ match }: RouteComponentProps<TParams>) => {
  const dispatch = useDispatch();
  const rowState = useSelector((state: AppState) => state.rowList);
  const sessionState = useSelector((state: AppState) => state.session);
  const modalState = useSelector((state: AppState) => state.modal);
  const formState = useSelector((state: AppState) => state.formList);
  const alertState = useSelector((state: AppState) => state.alert);
  const viewRemark = useSelector(getViewRemark);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // let styleObj: { [key: string]: any } ={}

  const viewRemarks = () => {
    const newSession = produce(sessionState, (draft) => {
      draft.viewRemark = !draft.viewRemark;
    });
    dispatch(startEditSession(newSession));
  };

  const downloadRemark = () => {
    downloadRemarkPdf(match.params.id);
  };

  useEffect(() => {
    dispatch(getSelectedForm(match.params.id));
    dispatch(startLoadFormDetails(match.params.id));
    const newModalState = produce(modalState, (draft) => {
      draft.show = false;
    });
    const newAlertState = produce(alertState, (draft) => {
      draft.id = match.params.id;
    });
    dispatch(startEditModal(newModalState));
    dispatch(startEditAlert(newAlertState));
  }, []);

  const renderRowList = () => {
    let rowListBySelectedFrom = rowState.filter((row) => {
      if (row.type === "form" && row.formId === alertState.id) {
        return row;
      }
    });
    return rowListBySelectedFrom.map((row, i) => {
      return <RowElement row={row} index={i} isPreview={true} />;
    });
  };

  function buildHtml(body: string) {
    var jQuery =
      '<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>';
    var boostrap =
      '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous" />';
    var react =
      '<script src="https://unpkg.com/react/umd/react.production.min.js" crossorigin></script><script src="https://unpkg.com/react-dom/umd/react-dom.production.min.js" crossorigin></script></script><script src="https://unpkg.com/react-bootstrap@next/dist/react-bootstrap.min.js" crossorigin></script> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" integrity="sha384-KyZXEAg3QhqLMpG8r+8fhAXLRk2vvoC2f3B09zVXn8CA5QIVfZOJ3BCsw2P0p/We" crossorigin="anonymous"/>';
    var header = boostrap + jQuery + react;
    console.log(body);

    // concatenate header string
    // concatenate body string
    var test =
      '<input id="4b4c5e4d-0ea7-440d-a59c-861761872ba8" type="text" class="form-control " placeholder="placeholder">';
    const firstInputItem = document.getElementsByTagName("input")[0];
    if (firstInputItem !== undefined) {
      console.log("aaaaaaaaaaaa");

      body =
        '<input id="0" type="text" class="form-control " placeholder="placeholder"/>';
    }
    return (
      "<!DOCTYPE html>" +
      "<html><head>" +
      header +
      "</head><body>" +
      body +
      "</body></html>"
    );
  }

  const downloadPreview = async () => {
    console.log(rowState);
    console.log("download preview444444444444");
    console.log("row state" + rowState);
    let content = "";
    // const root = document.getElementById("root");

    // const iframe = root?.querySelector('iframe');
    // const iframeRoot = iframe?.contentDocument?.getElementById("root");
    // //const html = iframeRoot?.innerHTML;
    // const html = root?.innerHTML;
    // if (html !== undefined) {
    //   content = html;

    // }
    const element = document.createElement("a");
    const file = new Blob([buildHtml(content)], { type: "text/plain" });

    element.href = URL.createObjectURL(file);
    element.download = "myFile.html";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();

    // const path = await formService.createFormDownload({name: 'page', body: content})
    // console.log(path);
  };

  const styleObj = () => {
    return formCss(formState);
  };

  const nameObj = () => {
    if (formState.length > 0) {
      return <div className="center-topic">{formState[0].name} </div>;
    }
  };

  useEffect(() => {});
  return (
    <div
      id="preview-component"
      className="container-fluid full-screen"
      style={{ ...styleObj() }}
    >
      <div className="d-flex">
        <div className="p-2 w-100 text-center">{nameObj()}</div>
        <div>
            <i
            className="btn"
            style={{ fontSize: "20pt" }}
            onClick={() => {
              downloadRemark();
            }}
            >
              R
            </i>
        </div>
        <div className="p-2 flex-shrink-1 radio-element">
          <Tooltip title="Deactive / Active View Remarks">
            <div className="d-flex justify-content-center flex-column">
              <label>Remarks&nbsp;</label>
              <div className="d-flex justify-content-center">
                <Switch
                  checked={sessionState.viewRemark}
                  onChange={() => {
                    viewRemarks();
                    console.log(sessionState.viewRemark);
                  }}
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={15}
                  uncheckedIcon={true}
                  checkedIcon={true}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={15}
                  width={30}
                  className="react-switch"
                  id="btn-outline"
                />
              </div>
            </div>
          </Tooltip>
        </div>
      </div>
      <div className=" row-list">{renderRowList()} </div>

      <ModalComponent
        isShow={modalState.show}
        properties={modalState.properties}
        formId={modalState.id}
      />
    </div>
  );
};

export default PreviewComponennt;
